/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/league.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.League
 */
export interface League {
    /**
     * @generated from protobuf field: optional string league_id = 1;
     */
    league_id?: string;
    /**
     * @generated from protobuf field: optional string league_name = 2;
     */
    league_name?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class League$Type extends MessageType<League> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.League", [
            { no: 1, name: "league_id", kind: "scalar", localName: "league_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "League ID." } },
            { no: 2, name: "league_name", kind: "scalar", localName: "league_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NFL", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "League Name." } }
        ]);
    }
    create(value?: PartialMessage<League>): League {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<League>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: League): League {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string league_id */ 1:
                    message.league_id = reader.string();
                    break;
                case /* optional string league_name */ 2:
                    message.league_name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: League, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string league_id = 1; */
        if (message.league_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.league_id);
        /* optional string league_name = 2; */
        if (message.league_name !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.league_name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.League
 */
export const League = new League$Type();
